import React from "react";

import { CafsTreeNodeType } from "../../../types/cafs-tree-node-type";

import { CafsAssign } from "./CafsAssign";
import { CafsCopy } from "./CafsCopy";
import { CafsCreate } from "./CafsCreate";
import { CafsDelete } from "./CafsDelete";
import { CafsEdit } from "./CafsEdit";
import { CafsMove } from "./CafsMove";
import { CafsStatus } from "./CafsStatus";

export type RenderActionIconsProps = {
  node: CafsTreeNodeType;
  allCafsNodes: CafsTreeNodeType[];
};

export function ActionIcons({ node, allCafsNodes }: RenderActionIconsProps) {
  return (
    <div className="flex flex-row gap-2 items-center">
      <CafsStatus node={node} />
      <CafsAssign node={node} />
      <CafsDelete node={node} />
      <CafsMove node={node} allCafsNodes={allCafsNodes} />
      <CafsEdit node={node} />
      <CafsCopy node={node} />
      <CafsCreate node={node} />
    </div>
  );
}
